<template>
  <svg width="23" height="36" viewBox="0 0 23 36" fill="inherit" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_269_289)">
      <path d="M21.6646 16.4109C22.5364 17.2898 22.5364 18.7172 21.6646 19.5961L8.27256 33.0961C7.40069 33.975 5.98477 33.975 5.11289 33.0961C4.24102 32.2172 4.24102 30.7898 5.11289 29.9109L16.9285 18L5.11987 6.08906C4.24799 5.21015 4.24799 3.78281 5.11987 2.9039C5.99174 2.02499 7.40766 2.02499 8.27954 2.9039L21.6715 16.4039L21.6646 16.4109Z" fill="inherit"/>
    </g>
    <defs>
      <clipPath id="clip0_269_289">
        <rect width="22.32" height="36" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>